import React from 'react';
import { motion } from 'framer-motion';

const ModalitiesSection = ({ services }) => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 360 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: 'easeOut' }}
        viewport={{ once: true, amount: 0.1 }}
      >
        <div
          style={{
            background:
              'linear-gradient(-45deg, #493F99 0%, #755EA8 67%, #D36CAA 100%)',
          }}
          className="w-full rounded-2xl md:rounded-[50px] p-6 md:px-14 md:pt-10 md:pb-16 flex flex-col gap-4"
        >
          {services.map((service, index) => {
            return (
              <div key={index}>
                <h2 className="text-[28px] md:text-[38px] 2xl:text-[48px] text-white font-bold">
                  {service.name}
                </h2>
                <div className="w-full">
                  <ul className="grid grid-cols-1 sm:grid-cols-2 list-disc">
                    {service.items.map((i, index) => {
                      return (
                        <li
                          key={index}
                          className="text-white text-lg md:text-xl 3xl:text-2xl ml-6 my-[4px] 3xl:my-[6px]"
                        >
                          {i}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </motion.div>
    </>
  );
};

export default ModalitiesSection;
